export type Event = {
  id: string;
  nome: string;
  descricao?: string | null;
  dataInicio: string;
  dataFim: string;
  local: string | null;
  cidade: string | null;
  estado: string | null;
  ativo: boolean;
  maxParticipantes?: number;
  participantesCount?: number;
};

type EventoApiDto = {
  id: string;
  nome: string;
  descricao: string | null;
  dataInicio: string;
  dataFim: string;
  cidade: string | null;
  estado: string | null;
  localNome: string | null;
  ativo: boolean;
  maxParticipantes: number;
  participantesCount?: number;
};

export const fromEventoDto = (dto: EventoApiDto): Event => ({
  id: dto.id,
  nome: dto.nome,
  descricao: dto.descricao,
  dataInicio: dto.dataInicio,
  dataFim: dto.dataFim,
  local: dto.localNome,
  cidade: dto.cidade,
  estado: dto.estado,
  ativo: dto.ativo,
  maxParticipantes: dto.maxParticipantes,
  participantesCount: dto.participantesCount,
});
